(function () {
  var root = document.querySelector('.cart-section[data-cart-page]');
  if (!root) return;

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart change failed');
      return r.json();
    });
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-qty]');
    if (!btn || !root.contains(btn)) return;
    e.preventDefault();
    var key = btn.getAttribute('data-key');
    if (!key) return;
    var wrap = btn.closest('.cart-item__quantity');
    if (!wrap) return;
    var input = wrap.querySelector('.cart-quantity__input');
    if (!input) return;
    var q = parseInt(input.value, 10);
    if (Number.isNaN(q)) q = 1;
    if (btn.getAttribute('data-cart-qty') === 'increase') q += 1;
    else q = Math.max(0, q - 1);
    input.value = String(q);
    changeLine(key, q).then(function () {
      window.location.reload();
    });
  });
})();
